/* Iveraco ring size guide: the on-screen sizer, the finger measurement and
   the US / India converter. The chart is rendered in Liquid.

   One pair of formulas drives all of it, the same pair the section's chart
   uses, so the three tools and the chart always agree:
     US size s      -> circumference 36.5 + 2.55 s mm
     Indian size n  -> circumference 40 + n mm
     diameter       =  circumference / pi

   The sizer is only as true as its scale. A browser cannot know how large a
   pixel is, so it starts from a per-device estimate, and a customer who wants
   it exact matches an outline to a bank card, 53.98 mm across on every card
   (ISO/IEC 7810 ID-1). That scale is kept in localStorage. */
(function init(root) {
  'use strict';
  if (!init.listening) {
    init.listening = true;
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-iv-rs]')); });
  }
  if (!root || root.dataset.rsBooted) return;
  root.dataset.rsBooted = '1';

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  var CARD_MM = 53.98;           /* the short side of an ID-1 card */
  var CARD_TALL_MM = 85.6;
  var US_MIN = 3, US_MAX = 13, IN_MIN = 1, IN_MAX = 35;
  var KEY = 'iv-ring-size-scale';

  var head = $('[data-rs-size-label]');
  var LBL = {
    us: head ? head.dataset.us : 'US',
    india: head ? head.dataset.in : 'India',
    out: root.dataset.labelOut || 'Outside our size range'
  };
  var th = $$('.iv-rs__table th');
  LBL.dia = th[2] ? th[2].textContent : 'Diameter';
  LBL.circ = th[3] ? th[3].textContent : 'Circumference';

  var circFromUs = function (s) { return 36.5 + 2.55 * s; };
  var usFromCirc = function (c) { return (c - 36.5) / 2.55; };
  var circFromIn = function (n) { return 40 + n; };
  var inFromCirc = function (c) { return c - 40; };

  /* 7 -> "7", 7.5 -> "7½" */
  function half(v) { var w = Math.floor(v); return (v - w > 0.25 ? (w === 0 ? '' : w) + '½' : String(w)); }

  /* A US reading within 0.15 of a half size reads as that size (0.15 of a US
     size is 0.12 mm of diameter, below what a finger can feel); otherwise it
     is shown as the two half sizes it falls between, never rounded silently.
     0.15 rather than 0.1 so India 14 reads US 7, as every published chart
     pairs them, instead of "6½–7". */
  function usText(c) {
    var s = usFromCirc(c);
    if (s < US_MIN - 0.25 || s > US_MAX + 0.25) return null;
    var nearest = Math.round(s * 2) / 2;
    if (Math.abs(s - nearest) <= 0.15) return half(nearest);
    var lo = Math.floor(s * 2) / 2;
    return half(lo) + '–' + half(lo + 0.5);
  }
  function inText(c) {
    var n = inFromCirc(c);
    if (n < IN_MIN - 0.5 || n > IN_MAX + 0.5) return null;
    return String(Math.round(n));
  }

  /* One decimal, halves rounded up, as Liquid's round: 1 does for the chart.
     toFixed alone gave 54.3 here for US 7 (54.35 is stored as 54.3499...)
     while the chart printed 54.4. */
  function mm1(v) { return (Math.round(v * 10 + 1e-6) / 10).toFixed(1); }

  function render(host, c) {
    if (!host) return;
    if (!c || !isFinite(c)) { host.innerHTML = ''; return; }
    var us = usText(c), india = inText(c), d = c / Math.PI;
    if (!us && !india) { host.innerHTML = '<p class="iv-rs__result-out">' + esc(LBL.out) + '</p>'; return; }
    host.innerHTML =
      '<dl class="iv-rs__sizes">' +
        cell(LBL.us, us || '–', true) + cell(LBL.india, india || '–', true) +
        cell(LBL.dia, mm1(d) + ' mm') + cell(LBL.circ, mm1(c) + ' mm') +
      '</dl>';
  }
  function cell(k, v, big) { return '<div class="iv-rs__size' + (big ? ' is-big' : '') + '"><dt>' + esc(k) + '</dt><dd>' + esc(v) + '</dd></div>'; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }

  /* ------------------------------------------------------------------ */
  /* Method 1: a ring that grows as you drag, drawn at true size.

     It opens on the ring, as ringsandi's does, but the circle's inner edge is
     the real diameter at the current scale, so a ring laid on the screen
     gives a real reading. The scale starts from a per-device estimate: CSS
     assumes 96 px to the inch, which is close on a desktop monitor but about
     25% small on a Retina laptop and 40% small on a phone. Matching a bank
     card replaces the estimate with the exact figure and is remembered. */
  var sizer = $('[data-rs-sizer]');
  if (sizer) {
    var scaleIn = $('[data-rs-scale]', sizer), diaIn = $('[data-rs-dia]', sizer);
    var card = $('[data-rs-card]', sizer), ring = $('[data-rs-ring]', sizer), label = $('[data-rs-ring-label]', sizer);
    var stageCard = $('[data-rs-stage="card"]', sizer), stageRing = $('[data-rs-stage="ring"]', sizer);
    var ringOut = $('[data-rs-result="ring"]', sizer);
    var guess = function () {
      var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (touch && Math.min(screen.width, screen.height) < 600) return 6.1;   /* phones */
      if (touch) return 5.0;                                                /* tablets */
      if ((window.devicePixelRatio || 1) >= 2) return 5.0;                   /* Retina laptops */
      return 96 / 25.4;                                                     /* desktop monitors */
    };
    var scale = guess(), saved = null;
    try { saved = parseFloat(localStorage.getItem(KEY)); } catch (e) {}
    var exact = !!(saved && saved >= 2.5 && saved <= 8);
    if (exact) scale = saved;
    scaleIn.value = scale;

    var clamp = function (v, lo, hi) { return Math.min(hi, Math.max(lo, v)); };
    var grid = function () { sizer.style.setProperty('--rs-cell', (5 * scale).toFixed(2) + 'px'); };  /* 5 mm grid */
    var drawCard = function () {
      card.style.width = (CARD_MM * scale).toFixed(1) + 'px';
      card.style.height = (CARD_TALL_MM * scale).toFixed(1) + 'px';
      card.style.borderRadius = (3.18 * scale).toFixed(1) + 'px';   /* ID-1 corner radius */
      grid();
    };
    var drawRing = function () {
      var d = parseFloat(diaIn.value), px = d * scale, c = d * Math.PI;
      ring.style.width = ring.style.height = px.toFixed(1) + 'px';
      ring.style.setProperty('--rs-band', (2 * scale).toFixed(1) + 'px');   /* a 2 mm band */
      ring.style.setProperty('--rs-ring-px', px.toFixed(1) + 'px');
      var us = usText(c), india = inText(c);
      label.innerHTML = us || india
        ? '<b>' + esc(LBL.us + ' ' + (us || '–')) + '</b><small>' + esc(LBL.india + ' ' + (india || '–')) + '</small>'
        : '';
      grid();
      render(ringOut, c);
    };
    var show = function (which) {
      stageCard.hidden = which !== 'card'; stageRing.hidden = which !== 'ring';
      $('[data-rs-calib-state="guess"]', sizer).hidden = exact;
      $('[data-rs-calib-state="exact"]', sizer).hidden = !exact;
    };
    scaleIn.addEventListener('input', function () { scale = parseFloat(scaleIn.value); drawCard(); });
    $$('[data-rs-scale-step]', sizer).forEach(function (b) {
      b.addEventListener('click', function () { scale = clamp(scale + parseFloat(b.dataset.rsScaleStep), 2.5, 8); scaleIn.value = scale; drawCard(); });
    });
    diaIn.addEventListener('input', drawRing);
    $$('[data-rs-dia-step]', sizer).forEach(function (b) {
      b.addEventListener('click', function () { diaIn.value = clamp(parseFloat(diaIn.value) + parseFloat(b.dataset.rsDiaStep), 13, 23.5).toFixed(2); drawRing(); });
    });
    $('[data-rs-calibrated]', sizer).addEventListener('click', function () {
      try { localStorage.setItem(KEY, String(scale)); } catch (e) {}
      exact = true; drawRing(); show('ring');
    });
    $('[data-rs-calibrate]', sizer).addEventListener('click', function () { drawCard(); show('card'); });
    drawRing(); show('ring');
  }

  /* ------------------------------------------------------------------ */
  /* Method 2: a measured length, round the finger or across a ring */
  var measure = $('[data-rs-measure]');
  if (measure) {
    var mode = 'circ', mm = $('[data-rs-mm]', measure), mOut = $('[data-rs-result="measure"]', measure);
    var calc = function () {
      var v = parseFloat(mm.value);
      if (!v || v <= 0) { render(mOut, null); return; }
      render(mOut, mode === 'circ' ? v : v * Math.PI);
    };
    $$('[data-rs-mode]', measure).forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.dataset.rsMode;
        $$('[data-rs-mode]', measure).forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
        mm.placeholder = mode === 'circ' ? '54' : '17.3';
        calc();
      });
    });
    mm.addEventListener('input', calc);
  }

  /* ------------------------------------------------------------------ */
  /* Method 3: convert a known size */
  var conv = $('[data-rs-convert]');
  if (conv) {
    var system = 'us', sel = $('[data-rs-size]', conv), cOut = $('[data-rs-result="convert"]', conv), sizeLabel = $('[data-rs-size-label]', conv);
    var fill = function () {
      var opts = [], v;
      if (system === 'us') for (v = US_MIN; v <= US_MAX; v += 0.5) opts.push([v, half(v)]);
      else for (v = IN_MIN; v <= IN_MAX; v += 1) opts.push([v, String(v)]);
      var def = system === 'us' ? 7 : 14;
      sel.innerHTML = opts.map(function (o) { return '<option value="' + o[0] + '"' + (o[0] === def ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('');
      sizeLabel.textContent = system === 'us' ? LBL.us : LBL.india;
    };
    var calcC = function () {
      var v = parseFloat(sel.value);
      render(cOut, system === 'us' ? circFromUs(v) : circFromIn(v));
      /* the matching chart row is marked so the answer can be found in it too */
      var c = system === 'us' ? circFromUs(v) : circFromIn(v), best = null, bestD = 9;
      $$('[data-rs-row]').forEach(function (r) {
        var d = Math.abs(circFromUs(parseFloat(r.dataset.rsRow)) - c);
        r.classList.remove('is-match'); if (d < bestD) { bestD = d; best = r; }
      });
      if (best) best.classList.add('is-match');
      $$('[data-rs-in-row]').forEach(function (r) { r.classList.toggle('is-match', system === 'in' && parseFloat(r.dataset.rsInRow) === v); });
    };
    $$('[data-rs-system]', conv).forEach(function (b) {
      b.addEventListener('click', function () {
        system = b.dataset.rsSystem;
        $$('[data-rs-system]', conv).forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
        fill(); calcC();
      });
    });
    sel.addEventListener('change', calcC);
    fill(); calcC();
  }
  /* ------------------------------------------------------------------ */
  /* Chart: US-first or India-first. Both tables are in the HTML and show
     stacked without the script; with it, a switch shows one at a time. */
  var tabs = $('[data-rs-chart-tabs]');
  if (tabs) {
    tabs.hidden = false;
    var showChart = function (which) {
      $$('[data-rs-chart]').forEach(function (t) { t.hidden = t.dataset.rsChart !== which; });
      $$('[data-rs-chart-tab]', tabs).forEach(function (x) { var on = x.dataset.rsChartTab === which; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
    };
    $$('[data-rs-chart-tab]', tabs).forEach(function (b) { b.addEventListener('click', function () { showChart(b.dataset.rsChartTab); }); });
    showChart('us');
    /* converting from an Indian size opens the Indian chart, and back */
    $$('[data-rs-system]').forEach(function (b) { b.addEventListener('click', function () { showChart(b.dataset.rsSystem); }); });
  }
})(document.querySelector('[data-iv-rs]'));
